// View-model types for the investor bank-accounts directory module.
// Produced by ../api/bankAccountsDirectoryParser.ts. Consumers
// (containers, components, composables) bind to these — never to the
// wire DTOs in ../api/bankAccountsDirectoryContracts.ts.

export enum BANK_ACCOUNT_STATUS {
  PENDING_VERIFICATION = 'pending_verification',
  VERIFICATION_IN_PROGRESS = 'verification_in_progress',
  VERIFIED = 'verified',
  VERIFICATION_FAILED = 'verification_failed',
  REJECTED = 'rejected',
}

export type BankAccountStatus = `${BANK_ACCOUNT_STATUS}` | string

export interface BankAccountInvestor {
  id: string
  investorType: string
  firstName: string | null
  lastName: string | null
}

export interface BankAccountRow {
  id: string
  bankName: string
  accountHolderName: string
  accountNumber: string
  ifscCode: string | null
  iban: string | null
  swiftCode: string | null
  currencyCode: string
  accountStatus: BankAccountStatus
  rejectionReason: string | null
  createdAt: string
  investor: BankAccountInvestor
}

export interface BankAccountsDirectoryListResponse {
  rowsCount: number
  rows: BankAccountRow[]
}

// ─── Request params ──────────────────────────────────────────────────────────

export interface GetBankAccountsDirectoryParams {
  page?: number
  limit?: number
  investorId?: string
  firstName?: string
  lastName?: string
  investorEmail?: string
  bankName?: string
  accountStatus?: BankAccountStatus
  currencyCode?: string
}
